import { Directive, Input } from "@angular/core";

import { User, UserRole } from "@shared/models/user.model";

import { BaseAuthorizationDirective } from "./base-authorization.directive";

@Directive({
  selector: "[hasRole]",
  standalone: true
})
export class HasRoleDirective extends BaseAuthorizationDirective {
  private _roles: UserRole[] = [];

  @Input() set hasRole(roles: UserRole | UserRole[]) {
    this._roles = Array.isArray(roles) ? roles : [roles];
    this.updateView();
  }

  protected override checkAuthorization(user: User): boolean {
    return this._roles.includes(user.role);
  }
}
